// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1AG43","footer":"Form_footer__kSSoq"};